export default __webpack_public_path__ + "static/media/logoBg-m.69e8656d.svg";